const ALGOLIA_RENDER = document.getElementById('algolia-render');
const SELECTOR_ITEMS = '[data-cetelem][data-loaded="false"]';
// const SELECTOR_ITEM  = `[data-id=${id}][data-cetelem][data-loaded="false"]`;
const ENDPOINT = 'api_funding_cetelem';
import Routing from '../../../../web/bundles/fosjsrouting/js/router';

/**
 * Fonctionne pas trop perdu de temps cela sera en dur.
 */
// region naze
const routes = require('../../../../web/js/fos_js_routes');
Routing.setRoutingData(routes);
// endregion

const route = '/api/vehicle/funding/cetelem/';
let lastFundingFetch = null;
const debounceTime = 500;
/**
 * @param {string} url
 * @param {number} id
 */
function funding(url, id) {
  console.log(url, id);

  fetch(url)
    .then((response) => {
      if (response.status === 200) {
        return response.text();
      }
    })
    .then((html) => {
      const domTarget = document.querySelector(`[data-id="${id}"][data-cetelem]`);
      if (domTarget) {
        domTarget.innerHTML = html;
        domTarget.dataset.loaded = "true";
        // initBOXA('CATALOG');
        // reloadVehicleData();
      }
    })
    .catch((err) => {
      console.log(err);
    });

};

const callback = (mutationsList, observer) => {
  for (let mutation of mutationsList) {
    const nodes = mutation.addedNodes;

    if (nodes.length > 0) {
      /** node {Node} **/
      nodes.forEach((node) => {
        //cas si on utilise un filtre ou chjarge
        if (node.classList && node.classList.contains('ais-infinite-hits--item') && window.location.pathname === "/recherche") {
          console.log(window.location);

          try {
            let config = node.querySelector('[data-cetelem][data-loaded="false"]');
            if (config && config.dataset) {

              let id = config.dataset['id'];
              // console.log(id);
              let url = `${route}${id}`;
              config.dataset.loaded = "true";
              funding(url, id);
              return;
            }
          } catch (e) {
            console.log(e);
          }
        }

        //cas du premier chargemeent
        else if (node.childNodes.length > 0) {

          node.childNodes.forEach((node) => {
            if (node.classList && node.classList.contains('ais-infinite-hits') && window.location.pathname === "/recherche" ) {
              console.log('elseif', window.location);
              const vehiclesList = node.childNodes;

              vehiclesList.forEach((vehicle) => {
                try {
                  const config = vehicle.querySelector('[data-cetelem][data-loaded="false"]');
                  if (config && config.dataset) {
                    let id = config.dataset['id'];
                    let url = `${route}${id}`;
                    config.dataset.loaded = "true";
                    funding(url, id);
                    return;
                  }
                } catch (e) {
                  console.log(e);
                }


              });

            }
          });


        }
      });
    }

  }
};

const observer = new MutationObserver(callback);
observer.observe(ALGOLIA_RENDER, {attributes: false, childList: true, subtree: true});




// WEBPACK FOOTER //
// ./app/Resources/assets/algolia/cetelem-box.js